import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Bare `/legal` from external links → root with LegalSheet on the default
 * "terms" segment. Same idea as legal.$segment.tsx but covers the no-segment
 * case.
 */
export const Route = createFileRoute("/legal/")({
  beforeLoad: () => {
    throw redirect({ to: "/", search: { legal: "terms" } });
  },
});
